import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "menu"]
  
  connect() {
    console.log("Sidebar controller connected!")
  }

  disconnect() {
    // Ensure body scrolling is restored when the controller is disconnected
    document.body.style.overflow = ""
  }
  
  toggle() {
    if (this.overlayTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }
  
  open() {
    this.overlayTarget.classList.remove("hidden")
    
    // Animate sidebar in
    this.menuTarget.style.transform = "translateX(-100%)"
    requestAnimationFrame(() => {
      this.menuTarget.style.transition = "transform 300ms ease-out"
      this.menuTarget.style.transform = "translateX(0)"
    })
    
    // Prevent body scrolling
    document.body.style.overflow = "hidden"
  }
  
  close() {
    // Animate sidebar out
    this.menuTarget.style.transform = "translateX(-100%)"
    
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
      // Reset styles
      this.menuTarget.style.transition = ""
      this.menuTarget.style.transform = ""
      // Restore body scrolling
      document.body.style.overflow = ""
    }, 300)
  }
}